<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size"
    viewBox="0 0 24 24"><!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
    <path fill="currentColor"
      d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z" />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'MaterialSymbolsDeleteOutline',
  props: {
    size: {
      type: [Number, String],
      default: "1em",
    },
  },
}
</script>